import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { VideoEndedComponent } from './videoapp/component/video-ended/video-ended.component';
import { VideoAppComponent } from './videoapp/videoapp.component';

const routes: Routes = [
  { path: ':sess', component: VideoAppComponent },
  { path: 'video-ended', component: VideoEndedComponent },
  { path: '', component: VideoAppComponent },
  { path: '', redirectTo: '', pathMatch: 'full' },
  { path: '**', redirectTo: '' },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
